<template lang="html">

    <aside class="accesos">
        
        <article class="empresas">

          <a :href="$t('portalempresas')" class="enlace-cover"></a>

          <div class="top-empresa column-center">
            <h2>¿Eres una empresa?</h2>
          </div>

          <div class="bottom-empresa column-center">
            <h2>Recluta el mejor talento</h2>
          </div>

        </article>

        <article class="titulados">

          <a :href="$t('portalalumno')" class="enlace-cover"></a>

          <div class="top-titulado column-center">
            <h2>¿Eres un titulado?</h2>
          </div>

          <div class="bottom-titulado column-center">
            <h2>Accede al mercado laboral</h2>
          </div>

        </article>
        
        <article class="estudiantes-ule">

          <a :href="$t('portalestudianteule')" class="enlace-cover"></a>

          <div class="top-estudiante-ule column-center">
            <h2>¿Eres estudiante de la ULE?</h2>
          </div>

          <div class="bottom-estudiante-ule column-center">
            <h2>Accede al mercado laboral</h2>
          </div>

        </article>


      </aside>
  
  </template>
  
  <script lang="js">
    export default {
      name: 'accesos',
    }
  </script>



// WEBPACK FOOTER //
// src/components/parts/accesos.vue